const DynamicElectionRoutingService = function ($http, $q, $window) {
    const service = this;

    const success = function (data) {
        return data.data;
    };

    const fault = function (data, status, headers) {
        return $q.reject(headers("exceptionMessage"));
    };

    const complete = function () {};

    service.getTime = function () {
        const url = __baseApiUrl__ + "/participant-web-services/rest/nonauth/service/activity/";
        return $http.get(url).then(success, fault).finally(complete);
    };

    service.getDetails = (id) => {
        const url =
            __baseApiUrl__ +
            `/participant-web-services/rest/accounts/account/${id.individual}/${id.ga}/`;
        return $http.get(url).then(success, fault).finally(complete);
    };

    service.getContactDetails = function () {
        const url =
            __baseApiUrl__ + "/participant-web-services/rest/partialauth/retrieveContactDetails/";
        return $http.get(url).then(success, fault).finally(complete);
    };
};

DynamicElectionRoutingService.$inject = ["$http", "$q", "$window"];
export default DynamicElectionRoutingService;
